export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  <path fill="currentcolor" fill-rule="evenodd" d="m5.452 12 2.886-5 2.887 5c1.283 2.222-.32 5-2.887 5-2.566 0-4.17-2.778-2.886-5Zm1.623.938 1.263-2.188 1.263 2.188a1.458 1.458 0 1 1-2.526 0Z" clip-rule="evenodd"/>
  <path fill="currentcolor" d="M13 8h6v1.5h-6V8Zm4 3h-4v1.5h4V11Z"/>
  <path fill="currentcolor" fill-rule="evenodd" d="M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6Zm2-.5h16a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5V6a.5.5 0 0 1 .5-.5Z" clip-rule="evenodd"/>
</svg>
`;
